import { IIncomingOffer } from '@/modules/offer/types/business-offer';
import styles from './index.module.sass';

export const ParamsSection = ({data}: { data: IIncomingOffer }) => {
    return (
        <div className={styles.bottomInformation}>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>клейковина</span>
            <span className={styles.value}>
              {data.gluten}
              <span className={styles.postfix}>%</span>
            </span>
          </div>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>влажность</span>
            <span className={styles.value}>
              {data.humidity}
              <span className={styles.postfix}>%</span>
            </span>
          </div>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>ИДК</span>
            <span className={styles.value}>{data.idk}</span>
          </div>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>натура</span>
            <span className={styles.value}>
              {data.nature}
              <span className={styles.postfix}>г/л</span>
            </span>
          </div>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>число падения</span>
            <span className={styles.value}>
              {data.cp}
              <span className={styles.postfix}>сек</span>
            </span>
          </div>
          <div className={styles.paramRequisite}>
            <span className={styles.label}>протеин</span>
            <span className={styles.value}>
              {data.protein}
              <span className={styles.postfix}>%</span>
            </span>
          </div>
        </div>
    )
}